import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=5ceb77a2&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=5ceb77a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb77a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ceb77a2')) {
      api.createRecord('5ceb77a2', component.options)
    } else {
      api.reload('5ceb77a2', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=5ceb77a2&scoped=true&", function () {
      api.rerender('5ceb77a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eKj0yD3V9saX/JS/comp/CookieBox.vue"
export default component.exports